import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'object-editor',
  templateUrl: './object-editor.component.html',
  styleUrls: ['./object-editor.component.scss']
})
export class ObjectEditorComponent implements OnInit {
  @Input() public data: any;
  @Output() public onUpdate = new EventEmitter<any>();

  public newKey: string;
  public newVal: string;

  constructor() {}

  ngOnInit() {}

  public addNew() {
    if (this.newKey && this.newVal) {
      if (!this.data) {
        this.data = {}; // ensure data is not null
      }
      this.data[this.newKey.trim().toLowerCase()] = this.newVal.trim();
      this.newKey = null;
      this.newVal = null;
      this.update();
    }
  }

  public updateValue(key: string, value: string) {
    value = value.trim();
    if (this.data && this.data[key] !== value) {
      this.data[key] = value.trim();
      this.update();
    }
  }

  public updateKey(prevKey: string, newKey: string) {
    newKey = newKey.trim().toLowerCase();
    if (this.data && prevKey !== newKey) {
      this.data[newKey] = this.data[prevKey];
      delete this.data[prevKey];
      this.update();
    }
  }

  public deleteKey(key: string) {
    if (this.data) {
      delete this.data[key];
      this.update();
    }
  }

  private update() {
    this.onUpdate.emit(this.data);
  }
}
